import React from 'react';
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';

// 🚀 최종 교정: 대표님이 찾으신 완벽한 6MB짜리 한글 폰트 파일명으로 정확히 매핑
Font.register({
  family: 'NotoSansKR',
  fonts: [
    { src: '/fonts/NotoSansKR-Regular.ttf', fontWeight: 'normal' }, 
    { src: '/fonts/NotoSansKR-Bold.ttf', fontWeight: 'bold' }
  ]
});

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'NotoSansKR',
    fontSize: 11,
    color: '#000000'
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'center',
    marginBottom: 30
  },
  table: {
    width: '100%',
    borderTop: '1px solid #000000',
    borderLeft: '1px solid #000000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000000',
    minHeight: 35
  },
  headerCell: {
    width: '20%',
    borderRight: '1px solid #000000',
    backgroundColor: '#f8fafc',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 4,
    paddingRight: 4
  },
  valueCell: {
    width: '30%',
    borderRight: '1px solid #000000',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 4,
    paddingRight: 4
  },
  headerCellWide: {
    width: '20%',
    borderRight: '1px solid #000000',
    backgroundColor: '#f8fafc',
    paddingTop: 14,
    paddingBottom: 14,
    paddingLeft: 4,
    paddingRight: 4
  },
  valueCellWide: {
    width: '80%',
    borderRight: '1px solid #000000',
    paddingTop: 14,
    paddingBottom: 14,
    paddingLeft: 12,
    paddingRight: 12
  },
  sectionTitleCell: {
    width: '100%',
    borderRight: '1px solid #000000',
    backgroundColor: '#f1f5f9',
    paddingTop: 10,
    paddingBottom: 10
  },
  textCenter: {
    width: '100%',
    textAlign: 'center',
    lineHeight: 1.4
  },
  textLeft: {
    width: '100%',
    textAlign: 'left',
    lineHeight: 1.4
  }
});

const AsReportPdf = ({ invoiceData = {} }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '정보 없음';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const days = ['일', '월', '화', '수', '목', '금', '토'];
    return `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일 ${days[d.getDay()]}요일`;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>차량 정비 내역서</Text>
        
        <View style={styles.table}>
          <View style={styles.row}>
            <View style={styles.headerCell}>
              <Text style={styles.textCenter}>차대번호</Text>
            </View>
            <View style={styles.valueCell}>
              <Text style={styles.textCenter}>{invoiceData.vin || '정보 없음'}</Text>
            </View>
            <View style={styles.headerCell}>
              <Text style={styles.textCenter}>차량 번호</Text>
            </View>
            <View style={styles.valueCell}>
              <Text style={styles.textCenter}>{invoiceData.carNumber || '정보 없음'}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.headerCell}>
              <Text style={styles.textCenter}>정비 일자</Text>
            </View>
            <View style={styles.valueCell}>
              <Text style={styles.textCenter}>{formatDate(invoiceData.asDate)}</Text>
            </View>
            <View style={styles.headerCell}>
              <Text style={styles.textCenter}>담당 정비사</Text>
            </View>
            <View style={styles.valueCell}>
              <Text style={styles.textCenter}>{invoiceData.mechanic || '정보 없음'}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.headerCell}>
              <Text style={styles.textCenter}>주행거리</Text>
            </View>
            <View style={styles.valueCell}>
              <Text style={styles.textCenter}>
                {invoiceData.mileage && invoiceData.mileage !== '0' && invoiceData.mileage !== '0km' 
                  ? `${Number(invoiceData.mileage.replace(/[^0-9]/g, '') || 0).toLocaleString()} km` 
                  : '0 km'}
              </Text>
            </View>
            <View style={styles.headerCell}>
              <Text style={styles.textCenter}>일반 / A/S</Text>
            </View>
            <View style={styles.valueCell}>
              <Text style={styles.textCenter}>{invoiceData.repairType || '일반'}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.sectionTitleCell}>
              <Text style={styles.textCenter}>차량 점검 / 수리 내역</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.headerCellWide}>
              <Text style={styles.textCenter}>입고 증상</Text>
            </View>
            <View style={styles.valueCellWide}>
              <Text style={styles.textLeft}>{invoiceData.symptom || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.headerCellWide}>
              <Text style={styles.textCenter}>점검 내역</Text>
            </View>
            <View style={styles.valueCellWide}>
              <Text style={styles.textLeft}>{invoiceData.inspection || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.headerCellWide}>
              <Text style={styles.textCenter}>원인</Text>
            </View>
            <View style={styles.valueCellWide}>
              <Text style={styles.textLeft}>{invoiceData.cause || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.headerCellWide}>
              <Text style={styles.textCenter}>조치 내역</Text>
            </View>
            <View style={styles.valueCellWide}>
              <Text style={styles.textLeft}>{invoiceData.action || ''}</Text>
            </View>
          </View>

          <View style={styles.row}>
            <View style={styles.headerCellWide}>
              <Text style={styles.textCenter}>수리 결과</Text>
            </View>
            <View style={styles.valueCellWide}>
              <Text style={styles.textLeft}>{invoiceData.result || ''}</Text>
            </View>
          </View>

        </View>
      </Page>
    </Document>
  );
};

export default AsReportPdf;